import { render } from "./MenuClassList.vue?vue&type=template&id=385bea40&scoped=true"
import script from "./MenuClassList.vue?vue&type=script&lang=js"
export * from "./MenuClassList.vue?vue&type=script&lang=js"

import "./MenuClassList.vue?vue&type=style&index=0&id=385bea40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385bea40"]])

export default __exports__